/**
 * De `value` van een handleidingtreffer in Ctrl+K (cmdk 1.1.1). cmdk filtert en sorteert op die
 * waarde met zijn eigen score, en werkt het filter voor een item alleen bij als de waarde
 * verandert — daarom staat de vraag erin. Achter een `/` en niet achter een spatie: zo scoort de
 * treffer lager dan een scherm waarvan een woord met de vraag begint, en kiest Enter het scherm,
 * zoals vóór de handleiding.
 */
export function helpCommandValue(rank: number, query: string): string {
  return `help ${rank}/${query}`
}
